module.exports = __webpack_public_path__ + "img/ufo-art-03_full.4c49309b.webp";